import { EventID, CalendarID } from "./constants";
export default function remoteUpdates(api, resolver) {
    function parseEvent(e) {
        if ("id" in e)
            e.id = resolver(e.id, EventID);
        if ("type" in e)
            e.type = resolver(e.type, CalendarID);
        e.start_date = e.start_date ? new Date(e.start_date) : null;
        e.end_date = e.end_date ? new Date(e.end_date) : null;
        return e;
    }
    function parseCalendar(c) {
        if ("id" in c)
            c.id = resolver(c.id, CalendarID);
        return c;
    }
    function eventUpdate(obj) {
        const event = parseEvent(obj.event);
        switch (obj.type) {
            case "add-event":
                api.exec(obj.type, {
                    id: event.id,
                    event: event,
                    skipProvider: true,
                });
                break;
            case "update-event":
                api.exec("update-event", {
                    id: event.id,
                    event: event,
                    skipProvider: true,
                });
                break;
            case "delete-event":
                api.exec("delete-event", {
                    id: event.id,
                    skipProvider: true,
                });
                break;
        }
    }
    function calendarUpdate(obj) {
        const calendar = parseCalendar(obj.calendar);
        switch (obj.type) {
            case "add-calendar":
                api.exec(obj.type, {
                    id: calendar.id,
                    calendar,
                    skipProvider: true,
                });
                break;
            case "update-calendar":
                api.exec("update-calendar", {
                    id: calendar.id,
                    calendar,
                    skipProvider: true,
                });
                break;
            case "delete-calendar":
                api.exec("delete-calendar", {
                    id: calendar.id,
                    skipProvider: true,
                });
                break;
        }
    }
    return {
        events: eventUpdate,
        calendars: calendarUpdate,
    };
}
//# sourceMappingURL=RemoteUpdates.js.map